export const NONE_VALUE = -1;

export function saveBlobAsFile(data: Blob, fileName: string) {
  const a = document.createElement('a');
  document.body.appendChild(a);

  a.style.display = 'none';
  const url = window.URL.createObjectURL(data);
  a.href = url;
  a.download = fileName;

  try {
    a.click();
  } finally {
    document.body.removeChild(a);
    window.setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 0);
  }
}
